// extracted by mini-css-extract-plugin
export var authorInfo = "CourseTestimonials-module--authorInfo--4164b";
export var authorPosition = "CourseTestimonials-module--authorPosition--1542a";
export var avatar = "CourseTestimonials-module--avatar--f918b";
export var card = "CourseTestimonials-module--card--ffe4f";
export var companyName = "CourseTestimonials-module--companyName--2d3ce";
export var content = "CourseTestimonials-module--content--82f8d";
export var contentWrapper = "CourseTestimonials-module--contentWrapper--81178";
export var loadMoreButton = "CourseTestimonials-module--loadMoreButton--b741e";
export var media = "CourseTestimonials-module--media--50cac";
export var more = "CourseTestimonials-module--more--c7252";
export var moreBtn = "CourseTestimonials-module--moreBtn--94664";
export var testimonial = "CourseTestimonials-module--testimonial--1257d";
export var title = "CourseTestimonials-module--title--ca1d6";
export var wrapper = "CourseTestimonials-module--wrapper--3012b";